module.exports = __webpack_public_path__ + "static/media/product_home_icon.591a7313.svg";